<template>
  <VModal ref="dialog" disable-backdrop-click @close="$emit('close')">
    <template #default="modalProps">
      <div class="rounded shadow-xs w-full h-full max-w-7xl mx-auto">
        <div class="rounded shadow-lg bg-white h-full overflow-hidden flex flex-col">
          <div class="px-4 sm:px-6 py-5 border-b">
            <div class="flex items-center justify-between">
              <div class="flex-1">
                <h1 class="text-sm">New Email Template</h1>
              </div>

              <div class="flex-none">
                <button
                  type="button"
                  class="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  @click="modalProps.close"
                >
                  <span class="sr-only">Close</span>
                  <svg
                    class="inline-flex h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <component
            :is="currentStep.component"
            :account-id="accountId"
            :email-template-data="emailTemplateData"
            @base-email-template:update="emailTemplateData.baseEmailTemplate = $event"
            @email-template-name:update="emailTemplateData.name = $event"
            @prev-step="currentStepName = 'template_base'"
            @next-step="currentStepName = 'template_details'"
            @created="handleCreated"
          />
        </div>
      </div>
    </template>
  </VModal>
</template>

<script>
export default {
  name: 'CreateEmailTemplateDialog',
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      steps: [
        { name: 'template_base', component: () => import('./BaseTemplateDetails.vue') },
        { name: 'template_details', component: () => import('./TemplateDetails.vue') },
      ],
      emailTemplateData: {
        name: '',
        baseEmailTemplate: null,
      },
      currentStepName: 'template_base',
    };
  },
  computed: {
    currentStep() {
      return this.steps.find((step) => step.name === this.currentStepName) || this.steps[0];
    },
  },
  methods: {
    handleCreated(emailTemplate) {
      this.$emit('created', emailTemplate);
      this.$refs.dialog.close();
    },
  },
};
</script>
